import { tmmInstance } from 'libraries/axios';

export const postPlaceBetReq = (body) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/Bet/PlaceBetRequest', body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
  );
};

export const postAutoBetReq = (body) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/Bet/RequestAutoBet', body)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      })
  );
};

export const postCashoutBetSlipReq = (body) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/Bet/CashOutBetSlip', body)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
  );
};

export const getBetSlipMatchesReq = (body) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/BetEvent/GetSlipEvents', body)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      })
  );
};

// BetBuilder API calls
// Combined odds plus the outcomes that would conflict with the current selection
export const calculateBetBuilderFilterReq = (body) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/api/BetBuilder/calculate-filter', body)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      })
  );
};

export const calculateBetBuilderOddsReq = (body) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/api/BetBuilder/calculate', body)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      })
  );
};
